import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const OPERATOR_COMPACT_MAX_WIDTH = 1366;
export const OPERATOR_COMPACT_MAX_HEIGHT = 768;

const OPERATOR_COMPACT_PATTERNS = [
  /^\/guias(?:\/|$)/,
  /^\/fojas(?:\/|$)/,
  /^\/repartos(?:\/|$)/,
  /^\/cargas\/repartos(?:\/|$)/,
  /^\/recepcion(?:\/|$)/,
  /^\/cargas\/recepcion(?:\/|$)/,
  /^\/tesoreria\/cobranzas(?:\/|$)/,
  /^\/cobranzas(?:\/|$)/,
  /^\/facturacion(?:\/|$)/,
  /^\/tarifas(?:\/|$)/,
  /^\/administracion\/tarifas(?:\/|$)/,
  /^\/clientes(?:\/|$)/,
  /^\/administracion\/clientes(?:\/|$)/,
  /^\/retiros(?:\/|$)/,
];

export function isOperatorCompactPath(pathname = '') {
  return OPERATOR_COMPACT_PATTERNS.some((pattern) => pattern.test(pathname));
}

function getViewportState() {
  if (typeof window === 'undefined') {
    return {
      isCompactHeight: false,
      isCompactWidth: false,
      isOperatorCompactViewport: false,
    };
  }

  const isCompactHeight = window.innerHeight <= OPERATOR_COMPACT_MAX_HEIGHT;
  const isCompactWidth = window.innerWidth <= OPERATOR_COMPACT_MAX_WIDTH;

  return {
    isCompactHeight,
    isCompactWidth,
    isOperatorCompactViewport: isCompactHeight || isCompactWidth,
  };
}

export function useOperatorCompactViewport() {
  const [viewportState, setViewportState] = useState(getViewportState);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const sync = () => setViewportState(getViewportState());

    sync();
    window.addEventListener('resize', sync);
    return () => window.removeEventListener('resize', sync);
  }, []);

  return viewportState;
}

export function useOperatorCompactRoute() {
  const location = useLocation();
  const viewportState = useOperatorCompactViewport();
  const isOperatorRoute = isOperatorCompactPath(location.pathname);

  return {
    ...viewportState,
    isOperatorRoute,
    isOperatorCompact: isOperatorRoute && viewportState.isOperatorCompactViewport,
  };
}
